<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">Music and Art</h4>
                    <div class="card-body text-justify">
                        <p class="lead text-justify inner-lead"><i>"Where words fail, music speaks 
                          Where words leave off, music begins."</i></p>
                          <p class="inner-lead">
                            In a multicultural society like ours, Art and Music serves as a unifying force and cuts across cultures.
                             It also improves motor skills builds self- confidence and contributes to overall personality development.</p>
                             <p class="inner-lead">With Art and Music also coming up as a rosy career- option these days, we impart training in the fields of Indian music (vocal, instrumental, classical, semi-classical) Western music (Guitar, Drums Keyboard and Piano)</p>
                            <div id="musicCarousel" class="carousel slide" data-ride="carousel">
                              <div class="carousel-indicators">
                                <button type="button" data-bs-target="#musicCarousel" *ngFor="let img of imgUrl, let i = index" class="{{ (i == 0) ? 'active' : '' }}" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1"
                                attr.data-bs-slide-to="{{i}}"></button>
                              </div>
                                <div class="carousel-inner text-center py-5 px-3">
                                  <div class="carousel-item" *ngFor="let img of imgUrl, let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
                                    <a appLazyload href="{{img}}" data-lightbox="Music"><img appLazyload [src]="img" alt="Music" class="img-fluid rounded"></a>
                                  </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#musicCarousel" data-bs-slide="prev">
                                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#musicCarousel" data-bs-slide="next">
                                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Next</span>
                                </button>
                              </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>